"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerConfig = exports.default = exports.LOG_SEVERITY = void 0;
var _date = require("./date");
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _debug = _interopRequireDefault(require("debug"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
var trackFormatter = function trackFormatter(track) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "  \\- track-".concat(index, "[").concat(track.id, "|").concat(track.kind, "|enabled-").concat(track.enabled, "|muted-").concat(track.muted, "]");
};
_debug.default.formatters.T = track => trackFormatter(track);
_debug.default.formatters.S = stream => {
  if (stream) {
    var tracks = stream.getTracks().reduce((output, item, index) => "\n".concat(trackFormatter(output, index - 1), "\n").concat(trackFormatter(item, index)) //eslint-disable-line
    );

    return "streamId(".concat(stream.id, ")").concat(tracks);
  }
  return null;
};
var LOG_SEVERITY = exports.LOG_SEVERITY = {
  none: 1,
  debug: 2,
  info: 8,
  warn: 16,
  error: 32
};
var getSeverityFromValue = severity => {
  return Object.keys(LOG_SEVERITY).find(key => LOG_SEVERITY[key] === severity) || LOG_SEVERITY.none;
};
var _config = /*#__PURE__*/new WeakMap();
class LoggerConfig {
  constructor() {
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: {
        debug: false,
        storeLogs: false,
        callback: false,
        level: LOG_SEVERITY.warn,
        filter: '*'
      }
    });
    _defineProperty(this, "setLogLevel", value => {
      var level = value;

      // eg: 'info', 'warn...'
      if (typeof value === 'string' && Object.keys(LOG_SEVERITY).includes(value === null || value === void 0 ? void 0 : value.toLowerCase())) {
        level = LOG_SEVERITY[value === null || value === void 0 ? void 0 : value.toLowerCase()];
      }
      switch (level) {
        case LOG_SEVERITY.none:
          _classPrivateFieldGet(this, _config).level = LOG_SEVERITY.none;
          break;
        case LOG_SEVERITY.debug:
          _classPrivateFieldGet(this, _config).level = LOG_SEVERITY.debug | LOG_SEVERITY.info | LOG_SEVERITY.warn | LOG_SEVERITY.error;
          break;
        case LOG_SEVERITY.info:
          _classPrivateFieldGet(this, _config).level = LOG_SEVERITY.info | LOG_SEVERITY.warn | LOG_SEVERITY.error;
          break;
        case LOG_SEVERITY.warn:
          _classPrivateFieldGet(this, _config).level = LOG_SEVERITY.warn | LOG_SEVERITY.error;
          break;
        case LOG_SEVERITY.error:
          _classPrivateFieldGet(this, _config).level = LOG_SEVERITY.error;
          break;
        default:
          _classPrivateFieldGet(this, _config).level = level;
      }
    });
    _defineProperty(this, "setLogFilter", filter => {
      _classPrivateFieldGet(this, _config).filter = filter;
    });
    this.setLogLevel(_classPrivateFieldGet(this, _config).level);
  }
  setConfig(_ref) {
    var {
      debug,
      callback,
      level,
      filter,
      storeLogs
    } = _ref;
    if (debug !== undefined) {
      _classPrivateFieldGet(this, _config).debug = debug;
    }
    if (callback !== undefined) {
      _classPrivateFieldGet(this, _config).callback = callback;
    }
    if (storeLogs !== undefined) {
      _classPrivateFieldGet(this, _config).storeLogs = storeLogs;
    }
    if (level !== undefined) {
      this.setLogLevel(level);
    }
    if (filter !== undefined) {
      this.setLogFilter(filter);
    }
  }
  getConfig() {
    return _classPrivateFieldGet(this, _config);
  }
}
var loggerConfig = exports.loggerConfig = new LoggerConfig();
var _name = /*#__PURE__*/new WeakMap();
var _log = /*#__PURE__*/new WeakMap();
var _logFromSeverity = /*#__PURE__*/new WeakMap();
var _logFromError = /*#__PURE__*/new WeakMap();
class Logger {
  constructor(_name2) {
    var _this = this;
    _classPrivateFieldInitSpec(this, _name, {
      writable: true,
      value: 'default'
    });
    _classPrivateFieldInitSpec(this, _log, {
      writable: true,
      value: function value() {
        var severity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LOG_SEVERITY.info;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var message = arguments.length > 2 ? arguments[2] : undefined;
        var {
          debug: enabled,
          level,
          callback,
          filter
        } = loggerConfig.getConfig();
        var now = new Date();
        var severityTxt = getSeverityFromValue(severity);
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        if (enabled && (level & severity) === severity) {
          var _console;
          var nowString = (0, _date.formatTime)(now);
          _debug.default.log = (_console = console) === null || _console === void 0 ? void 0 : _console[severityTxt].bind(console);
          _debug.default.enable(filter);
          (0, _debug.default)("myc:".concat(severityTxt, ":").concat(type.toLowerCase()))("".concat(nowString, " ").concat(message), ...rest);
        }
        if (typeof callback === 'function') {
          var _cleanRest$;
          var cleanRest = (0, _cloneDeep.default)(rest);
          if (cleanRest !== null && cleanRest !== void 0 && (_cleanRest$ = cleanRest[0]) !== null && _cleanRest$ !== void 0 && (_cleanRest$ = _cleanRest$.action) !== null && _cleanRest$ !== void 0 && (_cleanRest$ = _cleanRest$.feedItem) !== null && _cleanRest$ !== void 0 && (_cleanRest$ = _cleanRest$.feedItem) !== null && _cleanRest$ !== void 0 && _cleanRest$.content) {
            /// remove post content from logs
            cleanRest[0].action.feedItem.feedItem.content = '****';
          }
          var dataLog = {
            severity: severityTxt,
            date: now.toISOString(),
            type,
            message,
            data: cleanRest
          };
          callback(dataLog);
        }
      }
    });
    // prettier-ignore
    _classPrivateFieldInitSpec(this, _logFromSeverity, {
      writable: true,
      value: severity => function () {
        for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }
        var [message, ...rest] = params;
        return _classPrivateFieldGet(_this, _log).call(_this, severity, _classPrivateFieldGet(_this, _name), message, ...rest);
      }
    });
    // prettier-ignore
    _classPrivateFieldInitSpec(this, _logFromError, {
      writable: true,
      value: severity => function () {
        for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          params[_key3] = arguments[_key3];
        }
        var [message, error, ...rest] = params;
        if (message instanceof Error) {
          _classPrivateFieldGet(_this, _log).call(_this, severity, _classPrivateFieldGet(_this, _name), error, message, ...rest);
        } else {
          _classPrivateFieldGet(_this, _log).call(_this, severity, _classPrivateFieldGet(_this, _name), ...params);
        }
      }
    });
    _defineProperty(this, "debug", _classPrivateFieldGet(this, _logFromSeverity).call(this, LOG_SEVERITY.debug));
    _defineProperty(this, "info", _classPrivateFieldGet(this, _logFromSeverity).call(this, LOG_SEVERITY.info));
    _defineProperty(this, "log", this.info);
    _defineProperty(this, "warn", _classPrivateFieldGet(this, _logFromSeverity).call(this, LOG_SEVERITY.warn));
    _defineProperty(this, "error", _classPrivateFieldGet(this, _logFromError).call(this, LOG_SEVERITY.error));
    _defineProperty(this, "setName", name => {
      _classPrivateFieldSet(this, _name, name);
    });
    _classPrivateFieldSet(this, _name, _name2);
    if (!loggerConfig.getConfig().debug) {
      _debug.default.disable();
    }
  }
}
var _default = exports.default = Logger;